export default function Nav() {
  return (
    <header className="sticky top-0 z-50 border-b border-rule bg-bg/90 backdrop-blur">
      <div className="mx-auto flex max-w-[1280px] items-center justify-between px-6 py-4 md:px-10">
        <a
          href="#top"
          className="-mx-2 inline-flex min-h-[44px] items-center gap-3 px-2 text-ink no-underline"
        >
          <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-accent">
            — ai · nexenio
          </span>
        </a>
        <nav className="hidden items-center gap-2 text-sm text-fg-muted md:flex">
          <a href="#ocr" className="inline-flex min-h-[44px] items-center px-3 py-2 hover:text-ink">
            OCR
          </a>
          <a
            href="#sovereign"
            className="inline-flex min-h-[44px] items-center px-3 py-2 hover:text-ink"
          >
            Souveränität
          </a>
          <a
            href="#contact"
            className="inline-flex min-h-[44px] items-center px-3 py-2 hover:text-ink"
          >
            Kontakt
          </a>
        </nav>
        <a
          href="#contact"
          className="inline-flex min-h-[44px] items-center rounded-none border border-accent bg-accent px-4 font-mono text-[11px] font-semibold uppercase tracking-[0.12em] text-bg hover:bg-accent-deep"
        >
          Gespräch
        </a>
      </div>
    </header>
  );
}
